<button
  mat-fab
  class="bg-black"
  [matBadge]="checkoutData?.subTotalQuantity"
  [matBadgeHidden]="checkoutData?.subTotalQuantity == 0"
  (click)="onClickCart()"
>
  <mat-icon>shopping_cart</mat-icon>
</button>
